<template>
  <transition name="slide-fade">
    <slot />
  </transition>
</template>

<script setup lang="ts">

</script>

<style lang="scss">
.slide-fade-enter-active {
  transition: all 0.4s ease-out;
  // GIVE IT BOUNCE
  transition-timing-function: linear(0, 0.345 8.4%, 0.616 17.2%, 0.819 26.6%, 0.894 31.5%, 0.955 36.7%, 0.995 41.3%, 1.024 46.2%, 1.043 51.4%, 1.052 57.1%, 1.049 66%, 1.008 88.4%, 1);
  // LOL, https://easingwizard.com/ is fun though -> JUST A JOKE - TODO REMOVE FOR PROD
  //transition-timing-function: linear(0, 0.234 11.8%, 0.403 18.4%, 0.624 24.7%, 0.999 33.3%, 0.76 39.9%, 0.705 42.6%, 0.687 45.2%, 0.703 47.7%, 0.753 50.3%, 0.999 57.7%, 0.89 61.8%, 0.865 63.6%, 0.857 65.3%, 0.865 67%, 0.887 68.8%, 0.999 74.5%, 0.957 77.5%, 0.944 80.2%, 0.954 82.7%, 1 88.2%, 0.988 91.9%, 1);
}

.slide-fade-leave-active {
  transition: all 0.5s ease-in;
  // GIVE IT BOUNCE
  transition-timing-function: linear(0, 0.345 8.4%, 0.616 17.2%, 0.819 26.6%, 0.894 31.5%, 0.955 36.7%, 0.995 41.3%, 1.024 46.2%, 1.043 51.4%, 1.052 57.1%, 1.049 66%, 1.008 88.4%, 1);


}

.slide-fade-leave-to,
.slide-fade-enter-from {
  opacity: 0;
  /* height: 0px; */
  transform: translateY(-100%);
}

.slide-fade-leave-from,
.slide-fade-enter-to {
  opacity: 1;
  /* height: 32px; */
  transform: translateY(0);
}
</style>
